import React, { useEffect, useState } from 'react'
import { Bar } from 'react-chartjs-2'
import {
  Chart as ChartJS,
  LineElement,
  LineController,
  BarController,
  PointElement,
  LinearScale,
  CategoryScale,
  Filler,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js'
import FormDateRangePicker from '../../form-date-range-picker'
import moment from 'moment'
import { useGetEmployeeReport } from '../../../redux/employees/hook'
import LoadingBar from '../../loader-bar'

const EmployeeReport = () => {
  ChartJS.register(
    LineElement,
    LineController,
    BarController,
    PointElement,
    LinearScale,
    CategoryScale,
    Filler,
    BarElement,
    Title,
    Tooltip,
    Legend
  )
  const [start_date, setStartDate] = useState(
    moment().subtract(3, 'month').format('YYYY-MM-DD')
  )
  const [end_date, setEndDate] = useState(moment().format('YYYY-MM-DD'))

  const options = {
    responsive: true,
    // options: {
    //     plugins: {
    //       tooltip: {
    //         backgroundColor: 'rgb(236,243,251)',
    //         borderColor: 'rgb(236,243,251)',
    //       },
    //     },

    // },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 1,
        },
      },
    },
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: false,
        text: 'Chart.js Bar Chart',
      },
    },
  }
  const { data: employeeReport, isLoading: reportLoading } =
    useGetEmployeeReport(start_date, end_date)
  const [labels, setLabels] = useState([])

  const [data, setData] = useState({
    data: {
      labels,
      datasets: [
        {
          type: 'line',
          label: 'Active Employees',
          borderColor: 'rgb(255, 99, 132)',
          borderWidth: 2,
          fill: false,
          data: employeeReport?.employee_active_array?.reverse(),
        },
        {
          type: 'bar',
          label: 'Employees Added',
          backgroundColor: 'rgb(75, 192, 192)',
          data: employeeReport?.employee_added_array?.reverse(),
          borderColor: 'white',
          borderWidth: 2,
        },
        {
          type: 'bar',
          label: 'Employee Exit',
          backgroundColor: 'rgb(53, 162, 235)',
          data: employeeReport?.employee_exit_array?.reverse(),
        },
      ],
    },
  })

  useEffect(() => {
    if (employeeReport) {
      let data = {
        data: {
          labels,
          datasets: [
            {
              type: 'line',
              label: 'Active Employees',
              fill: true,
              borderWidth: 2,
              borderColor: 'green',
              tension: 0.5,
              pointRadius: 0.5,
              pointHoverRadius: 8,
              pointHoverBorderWidth: 5,
              pointBorderWidth: 0,
              pointBorderColor: 'rgb(0, 25, 132)',
              pointHoverBorderColor: 'rgb(239, 160, 11)',
              data: employeeReport?.employee_active_array?.reverse(),
            },
            {
              type: 'bar',
              label: 'Employees Added',
              backgroundColor: 'green',
              data: employeeReport?.employee_added_array?.reverse(),
              borderColor: 'white',
              borderWidth: 2,
            },
            {
              type: 'bar',
              label: 'Employees Exited',
              backgroundColor: 'red',
              data: employeeReport?.employee_exit_array?.reverse(),
            },
          ],
        },
      }
      data.data.labels = employeeReport?.formatted_months?.reverse()
      setData(data)
    }
  }, [employeeReport])

  return (
    <>
      {reportLoading ? (
        <LoadingBar loading={reportLoading} />
      ) : (
        <>
          <div className='flex md:flex-row flex-col pt-0 h-full pb-0 gap-3'>
            <div className='flex flex-col md:w-2/5 w-full border-r items-center p-3 px-4 bg-highlight'>
              <div className='text-[16px] font-extrabold'>
                EMPLOYEE ANALYSIS
              </div>
              <hr className='divider mt-2 -mb-1' />
              <div className='flex flex-row md:justify-end px-3 justify-start items-center w-fit !text-[13px] '>
                <FormDateRangePicker
                  start={start_date}
                  end={end_date}
                  setStartDate={setStartDate}
                  setEndDate={setEndDate}
                  extraClass='!h-[35px] border !min-w-fit'
                />
              </div>
              <hr className='divider -mt-1 mb-2 bg-gray-700' />
              <div className='flex flex-col gap-3 w-full p-2 px-3 border bg-white rounded-md'>
                <div className='flex justify-between text-[13px] font-extrabold w-full'>
                  <span>EMPLOYEES ADDED:</span>
                  <span>{employeeReport?.employees_added}</span>
                </div>
                <div className='flex justify-between text-[13px] font-extrabold w-full'>
                  <span>EMPLOYEES EXITED:</span>
                  <span>{employeeReport?.employees_exited}</span>
                </div>
                <div className='flex justify-between text-[13px] font-extrabold w-full'>
                  <span>EMPLOYEES TURNOVER RATE:</span>
                  <span>{employeeReport?.employee_turnover?.toFixed(2)} %</span>
                </div>
              </div>
            </div>
            <div className='flex flex-col items-center justify-center md:w-3/5 w-full h-full p-2 px-4'>
              <Bar
                data={data?.data}
                options={options}
                height={'120px'}
                width={'170px'}
              />
            </div>
          </div>
        </>
      )}
    </>
  )
}

export default EmployeeReport
